import {useDispatch, useSelector} from 'react-redux';
import {Button, Grid, Header, Modal, Popup, styles, Surface, Table, Text, useTheme} from '../../tmwx-design-web/src';
import {useEffect, useMemo, useState} from 'react';
import {usePermissions} from 'tmwx-design-common';
import {ColumnDef} from '@tanstack/react-table';
import {useTranslation} from 'react-i18next';
import {RootState} from '../../gui-common/redux/store';
import {Location} from 'gui-common/redux/data/location';
import {getATRLocationList} from 'gui-common/redux/action/efe/efeLocationAction';
import {getATRCompanyList} from "gui-common/redux/action/efe/providerAction";
import HandleAddLocation from "../../components/efe/HandleAddLocation";
import {Company} from "gui-common/redux/data/company";
import {clearLocationError, clearLocationResponse} from "gui-common/redux/action/atr/locationAction";

const EfeLocations = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const { hasRights } = usePermissions()
    const { roundness, padding } = useTheme()
    const locationList = useSelector<RootState, Location[]>(state => state.atrLocation.locationList);
    const locationCount = useSelector<RootState, number>(state => state.atrLocation.locationCount);
    const isLoading = useSelector<RootState, boolean>(state => state.atrLocation.isLoading);
    const activeCompany = useSelector<RootState, Company>(state => state.auth.activeCompany);
    const [showCompanies, setShowCompanies] = useState<boolean>(false)
    const [selectedLocation, setSelectedLocation] = useState<Location | null>(null)
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1)


    const closeDialog = () => {
        setShowCompanies(false)
        setSelectedLocation(null)
        setDialogOpen(false)
        dispatch(clearLocationError())
        dispatch(clearLocationResponse())
    }

    const handleShow = (location: any) => {
        setSelectedLocation(location)
        setShowCompanies(true)
    }

    const getMoreLocations = () => {
        let newPage = page + 1
        setPage(newPage)
        dispatch(getATRLocationList(newPage, activeCompany.id))
    }

    const handleAdd = () => {
        dispatch(clearLocationError())
        dispatch(clearLocationResponse())
        setDialogOpen(true)
        dispatch(getATRCompanyList())
    }

    const columns = useMemo<ColumnDef<Location>[]>(
        () => [
            {
                accessorKey: 'address',
                meta: t('atr.machines.location'),
                header: () => <Text bold>{t('atr.machines.location')}</Text>,
                size: 250
            },
            {
                accessorKey: 'latitude',
                meta: t('atr.locations.latitude'),
                header: () => <Text bold>{t('atr.locations.latitude')}</Text>,
            },
            {
                accessorKey: 'longitude',
                meta: t('atr.locations.longitude'),
                header: () => <Text bold>{t('atr.locations.longitude')}</Text>,
            },
            {
                accessorKey: 'company',
                meta: t('efe.electricityProvider'),
                header: () => <Text bold>{t('efe.electricityProvider')}</Text>,
                cell: ({ row }) => (
                    // <Button
                    //     variant='contained'
                    //     status='neutral'
                    //     size='small'
                    //     uppercase={false}
                    //     onPress={() => handleShow(row.original)}
                    // >
                    //     {t('showMore')}
                    // </Button>
                    <Text>
                        {row.original.companyName}
                    </Text>
                )
            },
            {
                header: () => <Text bold centered>{t('actions')}</Text>,
                id: 'actions',
                meta: t('actions'),
                type: 'actions',
                size: 80,
                cell: ({ row }) => (
                    <div style={{ ...styles.row }}>
                        {hasRights(['efe_location_list']) && (
                            <Popup
                                style={styles.marginRight4}
                                triggerComponent={
                                    <Button
                                        iconLeft={'pin_drop_outlined'}
                                        status='primary'
                                        size='small'
                                        onPress={() => window.open(`https://maps.google.com/?q=${row.original.latitude},${row.original.longitude}`)}
                                    />
                                }
                                type='hover'
                            >
                                <Surface style={{ padding: padding, width: 150 }} elevation={1} shadow>
                                    <Text>{t('atr.locations.showOnMap')}</Text>
                                </Surface>
                            </Popup>
                        )}
                    </div>
                )
            },
        ],
        [t]
    );

    useEffect(() => {
        if (hasRights(["efe_location_list"])) {
            let page = 1
            setPage(page)
            dispatch(getATRLocationList(page, activeCompany.id))
        }
    }, [dispatch, hasRights, activeCompany])

    return (
        <Surface style={{ height: '100vh', paddingTop: 8, paddingBottom: 8 }}>
            <Grid.Container style={{ borderRadius: roundness }} elevation={0} centered maxWidth='xl'>
                <Grid.Col>
                    <Table
                        columns={columns}
                        data={locationList}
                        loading={isLoading}
                        dense
                        useGlobalFilter
                        refreshData={() => {
                            let page = 1
                            setPage(page)
                            dispatch(getATRLocationList(page, activeCompany.id))
                        }}
                        fetchData={() => getMoreLocations()}
                        maxData={locationCount}
                        add={hasRights(['efe_location_list']) ? () => handleAdd() : undefined}
                        labels={{
                            add: t('add'),
                            deletePreferences: t('deletePreferences'),
                            jumpHere: t('jumpHere'),
                            page: t('page'),
                            refresh: t('refresh'),
                            row: t('row'),
                            rowsSelected: t('rowsSelected'),
                            savePreferencies: t('savePreferences'),
                            searchData: t('searchData'),
                            selectCurrentPageData: t('selectCurrentPageData'),
                            showAll: t('showAll'),
                            sizing: t('sizing')
                        }}
                    />
                </Grid.Col>
            </Grid.Container>

            {/*<Modal*/}
            {/*    visible={showCompanies}*/}
            {/*    type='dialog'*/}
            {/*    dialogMaxWidth='xs'*/}
            {/*    contentElevation={0}*/}
            {/*    closeModal={closeDialog}*/}
            {/*    header={(*/}
            {/*        <Header*/}
            {/*            title={t('efe.electricityProvider')}*/}
            {/*            actionRight={<Button iconLeft={'clear'} status='neutral' variant='ghost' onPress={closeDialog} />}*/}
            {/*        />*/}
            {/*    )}*/}
            {/*>*/}
                {/*{showCompanies && (*/}
                {/*    <Surface>*/}
                {/*        {selectedLocation && (*/}
                {/*            <Row*/}
                {/*                avatar={<Avatar iconName={'cases_outlined'} />}*/}
                {/*                title={selectedLocation.companyName}*/}
                {/*            />*/}
                {/*        )}*/}

                {/*    </Surface>*/}
                {/*)}*/}
            {/*</Modal>*/}

            <Modal
                visible={dialogOpen}
                type='dialog'
                dialogMaxWidth='m'
                contentElevation={0}
                closeModal={closeDialog}
                header={(
                    <Header
                        title={t('add')}
                        actionRight={<Button iconLeft={'clear'} status='neutral' variant='ghost' onPress={closeDialog} />}
                    />
                )}
            >
                <HandleAddLocation actionType={'add'} item={selectedLocation}
                                              onClose={closeDialog} />
            </Modal>
        </Surface>
    );
};

export default EfeLocations;
